import { useLocation } from "react-router-dom";

export default function useCurrentLocation() {
  const location = useLocation();

  const currentLocationIs = (currentLocation) => {
    return location.pathname === currentLocation;
  };
  return {
    currentLocationIs,
    location,
  };
}
